import { createToken, useEventChat } from "@event-chat/core";
import { Form } from "antd";
import { createContext, useCallback, useContext, useMemo, useRef } from "react";
import zod from "zod";
const AntdCom = {};
const FormEventContext = createContext({});
const getStringValue = (values)=>values.find((item)=>void 0 !== item && (!Array.isArray(item) || item.length > 0));
const useForm = (options, formInit)=>{
    const { group, name, focusField } = formInit ?? {};
    const [form] = Form.useForm(formInit ? {
        ...formInit,
        focusField: focusField ?? (()=>{})
    } : void 0);
    const formName = useMemo(()=>getStringValue([
            name,
            options?.name
        ]) ?? createToken('form-event'), [
        name,
        options?.name
    ]);
    const groupName = useMemo(()=>getStringValue([
            group,
            options?.group
        ]), [
        group,
        options?.group
    ]);
    const { emit } = useEventChat(formName, {
        schema: zod.array(zod.object({
            name: zod.union([
                zod.string(),
                zod.number(),
                zod.array(zod.union([
                    zod.string(),
                    zod.number()
                ]))
            ]),
            value: zod.unknown()
        })),
        callback: ({ detail })=>detail.forEach((item)=>{
                emit({
                    detail: item.value,
                    name: item.name
                });
            }),
        group: groupName
    });
    const formInstance = useMemo(()=>Object.assign(formInit ?? {}, form, {
            group: groupName,
            name: formName,
            emit
        }), [
        form,
        formInit,
        groupName,
        formName,
        emit
    ]);
    return [
        formInstance
    ];
};
const useFormInstance = ()=>{
    const FormCom = useFormCom();
    const form = FormCom.useFormInstance();
    const { group, name, emit } = useFormEvent();
    return Object.assign(form, {
        group,
        name,
        emit
    });
};
const useFormCom = ()=>{
    const CustomForm = AntdCom.form;
    return CustomForm ?? Form;
};
const useFormEvent = ()=>{
    const record = useContext(FormEventContext);
    return record;
};
const useFormItemEmit = (item)=>{
    const itemRef = useRef(null);
    const emit = useCallback((detail)=>{
        const inputRef = item ?? itemRef;
        inputRef.current?.emit(detail);
    }, [
        item,
        itemRef
    ]);
    return [
        item ?? itemRef,
        emit
    ];
};
export { AntdCom, FormEventContext, getStringValue, useForm, useFormCom, useFormEvent, useFormInstance, useFormItemEmit };
